import type { ColumnDefinition } from "@frui.ts/dataviews";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import MunicipalitiesViewModel from "viewModels/timeCharges/distributorEnums/municipalities/municipalitiesViewModel";
import type Municipality from "entities/municipality";
import ListView from "views/common/list";

const MunicipalitiesView: ViewComponent<MunicipalitiesViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<Municipality>[] = [
    { property: "name", title: vm.translateAttribute("name") },
    { property: "regionId", title: vm.translateAttribute("regionId"), valueFormatter: props => vm.regionName(props.value) },
    { property: "internalIdent", title: vm.translateAttribute("internalIdent") },
  ];

  return (
    <>
      <ListView vm={vm} columns={columns} />
    </>
  );
});

registerView(MunicipalitiesView, MunicipalitiesViewModel);
